import { render, staticRenderFns } from "./AcceptContract.vue?vue&type=template&id=0345a82b&scoped=true"
import script from "./AcceptContract.vue?vue&type=script&lang=js"
export * from "./AcceptContract.vue?vue&type=script&lang=js"
import style0 from "./AcceptContract.vue?vue&type=style&index=0&id=0345a82b&prod&scoped=true&lang=css"
import style1 from "./AcceptContract.vue?vue&type=style&index=1&id=0345a82b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345a82b",
  null
  
)

export default component.exports